import { takeEvery } from 'redux-saga/effects';
import { fetchLayers } from './fetch-layers';

export function* fetchLayersSaga() {
  yield takeEvery(['FETCH_LAYERS'], fetchLayers);
}
